<template>
  <div class="content">
    <div class="page">
      <h2>视频信息管理</h2>
      <div class="message">
        采用实景指挥系统，通过小区/社区高点图像，统筹全局，联动细节。
      </div>
      <img
        src="../../../../assets/image/residentialQuartersImg/u942.png"
        alt=""
      />
    </div>
  </div>
</template>
 
<script>
export default {
  components: {},
  name: "",
  data() {
    return {};
  },

  methods: {},
};
</script>
 
<style scoped lang="scss">
.content {
  padding: 0 16%;
  box-sizing: border-box;
  min-height: calc(100vh - 387px);
  width: 100%;
  margin-bottom: 50px;
  .page {
    margin-top: 50px;
    width: 100%;
    height: 720px;
    background-color: #fff;
    box-sizing: border-box;
    padding: 30px;
    // position: relative;
    text-align: center;
    > h2 {
      text-align-last: left;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333333;
      margin: 10px 0 30px 0;
    }
    .message {
      text-align-last: left;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6b6b6b;
      margin-bottom: 50px;
    }
  }
}
</style>